// extracted by mini-css-extract-plugin
export default {"credits":"credits_credits__8Uvc1","showButton":"credits_showButton__6XHc2","goBack":"credits_goBack__qbE03"};